import type { Preset } from '@primeuix/themes/types';
import type { LaraBaseDesignTokens } from './base/index.d';

import accordion from '@primeuix/themes/lara/accordion';
import autocomplete from '@primeuix/themes/lara/autocomplete';
import avatar from '@primeuix/themes/lara/avatar';
import badge from '@primeuix/themes/lara/badge';
import base from '@primeuix/themes/lara/base';
import blockui from '@primeuix/themes/lara/blockui';
import breadcrumb from '@primeuix/themes/lara/breadcrumb';
import button from '@primeuix/themes/lara/button';
import card from '@primeuix/themes/lara/card';
import carousel from '@primeuix/themes/lara/carousel';
import cascadeselect from '@primeuix/themes/lara/cascadeselect';
import checkbox from '@primeuix/themes/lara/checkbox';
import chip from '@primeuix/themes/lara/chip';
import colorpicker from '@primeuix/themes/lara/colorpicker';
import confirmdialog from '@primeuix/themes/lara/confirmdialog';
import confirmpopup from '@primeuix/themes/lara/confirmpopup';
import contextmenu from '@primeuix/themes/lara/contextmenu';
import datatable from '@primeuix/themes/lara/datatable';
import dataview from '@primeuix/themes/lara/dataview';
import datepicker from '@primeuix/themes/lara/datepicker';
import dialog from '@primeuix/themes/lara/dialog';
import divider from '@primeuix/themes/lara/divider';
import dock from '@primeuix/themes/lara/dock';
import drawer from '@primeuix/themes/lara/drawer';
import editor from '@primeuix/themes/lara/editor';
import fieldset from '@primeuix/themes/lara/fieldset';
import fileupload from '@primeuix/themes/lara/fileupload';
import floatlabel from '@primeuix/themes/lara/floatlabel';
import galleria from '@primeuix/themes/lara/galleria';
import iconfield from '@primeuix/themes/lara/iconfield';
import iftalabel from '@primeuix/themes/lara/iftalabel';
import image from '@primeuix/themes/lara/image';
import imagecompare from '@primeuix/themes/lara/imagecompare';
import inlinemessage from '@primeuix/themes/lara/inlinemessage';
import inplace from '@primeuix/themes/lara/inplace';
import inputchips from '@primeuix/themes/lara/inputchips';
import inputgroup from '@primeuix/themes/lara/inputgroup';
import inputnumber from '@primeuix/themes/lara/inputnumber';
import inputotp from '@primeuix/themes/lara/inputotp';
import inputtext from '@primeuix/themes/lara/inputtext';
import knob from '@primeuix/themes/lara/knob';
import listbox from '@primeuix/themes/lara/listbox';
import megamenu from '@primeuix/themes/lara/megamenu';
import menu from '@primeuix/themes/lara/menu';
import menubar from '@primeuix/themes/lara/menubar';
import message from '@primeuix/themes/lara/message';
import metergroup from '@primeuix/themes/lara/metergroup';
import multiselect from '@primeuix/themes/lara/multiselect';
import orderlist from '@primeuix/themes/lara/orderlist';
import organizationchart from '@primeuix/themes/lara/organizationchart';
import overlaybadge from '@primeuix/themes/lara/overlaybadge';
import paginator from '@primeuix/themes/lara/paginator';
import panel from '@primeuix/themes/lara/panel';
import panelmenu from '@primeuix/themes/lara/panelmenu';
import password from '@primeuix/themes/lara/password';
import picklist from '@primeuix/themes/lara/picklist';
import popover from '@primeuix/themes/lara/popover';
import progressbar from '@primeuix/themes/lara/progressbar';
import progressspinner from '@primeuix/themes/lara/progressspinner';
import radiobutton from '@primeuix/themes/lara/radiobutton';
import rating from '@primeuix/themes/lara/rating';
import ripple from '@primeuix/themes/lara/ripple';
import scrollpanel from '@primeuix/themes/lara/scrollpanel';
import select from '@primeuix/themes/lara/select';
import selectbutton from '@primeuix/themes/lara/selectbutton';
import skeleton from '@primeuix/themes/lara/skeleton';
import slider from '@primeuix/themes/lara/slider';
import speeddial from '@primeuix/themes/lara/speeddial';
import splitbutton from '@primeuix/themes/lara/splitbutton';
import splitter from '@primeuix/themes/lara/splitter';
import stepper from '@primeuix/themes/lara/stepper';
import steps from '@primeuix/themes/lara/steps';
import tabmenu from '@primeuix/themes/lara/tabmenu';
import tabs from '@primeuix/themes/lara/tabs';
import tabview from '@primeuix/themes/lara/tabview';
import tag from '@primeuix/themes/lara/tag';
import terminal from '@primeuix/themes/lara/terminal';
import textarea from '@primeuix/themes/lara/textarea';
import tieredmenu from '@primeuix/themes/lara/tieredmenu';
import timeline from '@primeuix/themes/lara/timeline';
import toast from '@primeuix/themes/lara/toast';
import togglebutton from '@primeuix/themes/lara/togglebutton';
import toggleswitch from '@primeuix/themes/lara/toggleswitch';
import toolbar from '@primeuix/themes/lara/toolbar';
import tooltip from '@primeuix/themes/lara/tooltip';
import tree from '@primeuix/themes/lara/tree';
import treeselect from '@primeuix/themes/lara/treeselect';
import treetable from '@primeuix/themes/lara/treetable';
import virtualscroller from '@primeuix/themes/lara/virtualscroller';

export default {
    ...base,
    components: {
        accordion,
        autocomplete,
        avatar,
        badge,
        blockui,
        breadcrumb,
        button,
        datepicker,
        card,
        carousel,
        cascadeselect,
        checkbox,
        chip,
        colorpicker,
        confirmdialog,
        confirmpopup,
        contextmenu,
        dataview,
        datatable,
        dialog,
        divider,
        dock,
        drawer,
        editor,
        fieldset,
        fileupload,
        iftalabel,
        floatlabel,
        galleria,
        iconfield,
        image,
        imagecompare,
        inlinemessage,
        inplace,
        inputchips,
        inputgroup,
        inputnumber,
        inputotp,
        inputtext,
        knob,
        listbox,
        megamenu,
        menu,
        menubar,
        message,
        metergroup,
        multiselect,
        orderlist,
        organizationchart,
        overlaybadge,
        popover,
        paginator,
        password,
        panel,
        panelmenu,
        picklist,
        progressbar,
        progressspinner,
        radiobutton,
        rating,
        ripple,
        scrollpanel,
        select,
        selectbutton,
        skeleton,
        slider,
        speeddial,
        splitter,
        splitbutton,
        stepper,
        steps,
        tabmenu,
        tabs,
        tabview,
        textarea,
        tieredmenu,
        tag,
        terminal,
        timeline,
        togglebutton,
        toggleswitch,
        tree,
        treeselect,
        treetable,
        toast,
        toolbar,
        tooltip,
        virtualscroller
    }
} satisfies Preset<LaraBaseDesignTokens>;
